import React,{useEffect, useState} from "react";
import {getBrands} from "../../service/myProductService";
import {chunkArray,ResponsiveSliderTop } from "../../utils/constant";
import Images from "../Images/Img";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
const BrandList = ()=>{
    const [data, setData] = useState([]);
    const loadBrand = ()=>{
        try{
         getBrands().then((response)=>{
                if(+response.status === 200){
                    setData(response['message']);
                }
            });
        }catch(e){console.log(e)}
    }
    useEffect(()=>{
        loadBrand();
    },[]);
    if(data.length>0){
    return(
        <div className="hot__brand">
        <div className="container m-auto p-0">
            <div className="row row--maint m-0 pb-4">
                <div className="col-12 px-0">
                    <div className="maint__title">
                        <div className="row m-0">
                            <div className="maint__title--left col-3 px-0">
                                <h2 className="float-start fw-bold ">Thương hiệu nổi bật</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="position-relative">
                            {
                            data.length > 0 ? (
                              <Carousel key="Brand"
                                responsive={ResponsiveSliderTop}
                                showDots={false}
                                autoPlay={true}
                                autoPlaySpeed={5000}
                                infinite={true}
                                swipeable={true}
                                rewind={true}
                              >
                                {
                                chunkArray(data, 12).map((group, groupIndex) => (
                                    <div key={groupIndex} className="mant__item  my-auto">
                                        <div className="row row-gap-4 m-0 mx-2">
                                        {
                                            group.map((brand, index) => (
                                                <div key={index} className="col-2 pading-brand">
                                                    <div className="hot__brand--content bg-white">
                                                        <a href={"/"+brand.url_key+'.html'}>
                                                            <div className="w-100 h-100">
                                                                <Images imgTitle={brand.name} url={brand.logo} className="w-100 img--brand" style=""/>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                        </div>
                                    </div>
                                ))
                                }
                              </Carousel>
                            ) : (null)
                          }
                    </div>
                </div>
            </div>
        </div>  
    </div>
    )
}else{return null;}
}
export default BrandList;